<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-17 11:38:09
 * @Description: 维保合同添加
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="新增"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="110px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="客户名称"
              prop="khmc"
            >
              <template>
                <el-select
                  v-model="fd.khmc"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in list"
                    :key="item.id"
                    :label="item.khmc"
                    :value="item.khmc"
                  />
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <!-- <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="xmmc"
            >
              {{ xmmc || '-' }}
            </el-form-item>
          </el-col> -->
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同名称"
              prop="htmc"
            >
              <el-input
                v-model="fd.htmc"
                class="c-form__input"
                autocomplete="off"
                maxlength="100"
                placeholder="请输入合同名称"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同编号"
              prop="htbh"
            >
              <el-input
                v-model="fd.htbh"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入合同编号！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同金额（元）"
              prop="htje"
            >
              <el-input
                v-model="fd.htje"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入合同金额"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同有效期"
              prop="yxq"
            >
              <hm-date-range
                v-model="fd.yxq"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :clearable="true"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同文件"
              prop="fileId"
            >
              <hm-upload
                ref="fileUpload"
                class="u-inline-block"
                :data="uploadFd"
                :action="uploadUrl"
                :headers="headers"
                :auto-upload="true"
                :show-file-list="true"
                :before-upload="handleBeforeUpload"
                :prepare-url="prepareUrl"
                :on-remove="delFile"
                :on-error="handleErrorUpload"
                :on-success="handleSuccess"
                :on-exceed="handleExceed"
                :limit="1"
              >
                <k-button
                  btn-text="上传"
                  :auth-type="true"
                  type="primary"
                  icon="kestrel-icon ki-cloud-upload"
                  plain
                />
                <template> *只能上传10m以内的文件* </template>
              </hm-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wbhtManageService } from './wbht.service.js';
import config from '@/config.js';
export default {
  name: 'AddDialog',
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载

      /* 表单参数 Start */

      // actionUrl: `${ctxPrefix}${iffApi}/wbht/upload`,
      /* 表单参数 Start */
      fd: {
        khmc: null, // 客户名称
        htmc: null, // 合同名称
        htbh: null,
        htje: null,
        yxq: [], // 有效期
        yxqq: null,
        yxqz: null,
        fileId: null
      },
      /* 表单参数 End */
      // 获取客户信息
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      // 客户名称存储list
      list: [],
      /* 表单校验规则 Start */
      fdRules: {
        khmc: [this.$validUtils.required('客户名称')],
        htmc: [this.$validUtils.required('合同名称')],
        htje: [
          this.$validUtils.required('合同金额'),
          this.$HMValidator.money('合同金额', 16, 2)
        ],
        yxq: [
          // 检验时间范围起不能晚于时间范围止
          this.$HMValidator.dateRange('合同有效日期'),
          // 是否都必填（非必需校验）
          this.$HMValidator.dateRangeAllMust('合同有效日期')
        ],
        htbh: [this.$validUtils.required('合同编号')],
        fileId: [this.$validUtils.required('合同文件')]
      },
      /* 文件服务器对接参数 Start */
      headers: { // 请求头部配置
        [config.serverHeaderTokenName]: this.$HMCookies.get(config.serverHeaderTokenName)
      },
      prepareUrl: config.prepareUrl, // 上传预加载服务地址
      uploadUrl: config.uploadUrl, // 上传服务地址
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'htwj',
            value: null
          }
        ]
      },
      uploadFileList: [], // 上传按钮绑定值
      deleteFileList: [] // 待删除附件的id集合
      /* 表单校验规则 End */
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },

    /**
     * 文件上传
     */
    handleSuccess (response) {
      this.$alert('上传成功', '提示', {
        confirmButtonText: '确定',
        type: 'success',
        callback: action => {
          this.fd.fileId = response.fileId;
        }
      });
    },
    // 删除上传的文件
    delFile () {
      this.fd.fileId = null;
    },
    /**
     * @description: 文件超出个数限制时的钩子
     * @param {*}
     * @return {*}
     */
    handleExceed (files, fileList) {
      this.$alert('只能上传一个文件！', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        callback: action => {
        }
      });
    },
    /**
     * @description: 上传前检查文件大小，限制上传大小为 1M
     * @param {*}
     * @return {*}
     */
    handleBeforeUpload (file) {
      const sizeLimit = (file.size / 1024 / 1024) > 10;
      if (sizeLimit) {
        this.$message.error('上传的附件不得超过10M');
        return false;
      }
    },
    /**
     * @description: 上传失败
     * @param {*}
     * @return {*}
     */
    handleErrorUpload (err, file, fileList) {
      try {
        const { message } = err;
        const { errorMsg } = JSON.parse(message);
        this.$alert(errorMsg, '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: () => {
            this.loading = false;
          }
        });
      } catch (error) {
        this.loading = false;
      }
    },

    /**
     * 获取客户名称
     */
    getkhmcList () {
      wbhtManageService.getKhmc(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
          this.list = this.page.rows;
          console.log(this.list);
        });
    },
    /**
     * 获取项目名称
     * <!--  @click.native="getXmmc(item.xmmc)" -->
     */
    // getXmmc (str) {
    //   this.xmmc = str;
    //   console.log(this.xmmc);
    // },

    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate(valid => {
        if (valid) {
          _this.loading = true;
          _this.fd.yxqq = _this.fd.yxq[0];
          _this.fd.yxqz = _this.fd.yxq[1];
          wbhtManageService.save(_this.fd)
            .then(rsp => {
              _this.$alert('添加成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', '');
              _this.$emit('callback');
            })
            .catch(err => {
              console.log('请假类型增加错误！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    }
  },
  created () {
    this.getkhmcList();
  }
};

</script>
